import React, {Component, lazy, Suspense} from 'react';

import {AppContext} from '../../../../AppModule/Context';

import SuspenseLoader from '../../../common/genericComponents/suspenseLoader/suspenseLoader';

import './personalPageSchedulingComponent.css';

const ClientScheduleRequestContainer = lazy(
  () => import('../widget/clientScheduleRequestContainer'),
);

class PersonalPageSchedulingComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = () => {};

  render() {
    return (
      <div className="personal-page-scheduling-component">
        <Suspense fallback={<SuspenseLoader />}>
          <ClientScheduleRequestContainer
            ref={this.clientScheduleRequestContainerRef}
            sendGA={this.props.sendGA}
            callSendMessageFunc={this.props.callSendMessageFunc}
            mentor={this.props.extendedMentorDto}
            currentUser={this.context.currentUser}
            sessionTemplateDto={this.props.extendedMentorDto.sessionTemplateDto}
            widgetDto={this.props.widgetDto}
          />
        </Suspense>
      </div>
    );
  }
}
PersonalPageSchedulingComponent.contextType = AppContext;

export default PersonalPageSchedulingComponent;
